<div class="myslides">
    <div class="ombre"></div>
    <swiper [config]="options">
        <div class="swiper-wrapper">
            <div *ngFor="let image of images;let i=index" class="swiper-slide" [ngStyle]="{'background': 'url('+image+')','background-position':'center','background-size':'cover'}">
            </div>
        </div>
        <div class="swiper-pagination"></div>
    </swiper>
    <div class="slider-description" #description>
        <img class="logo" src="assets/images/logos/logo.png" alt="logo">
        <a routerLink="/carte" class="add-to-cart btn">
            <i class="flaticon-shopping"></i>
            <span>Commander</span>
        </a>
        <div class="gradient-border" id="box" *ngIf="enablePayement">
            <img src="assets/images/payamenet2.png" alt="Paiement par carte bancaire">
        </div>
    </div>
</div>